module.exports = __webpack_public_path__ + "img/module-onboarding.c0b58749.svg";